(function(angular) {
    class WtBreadcrumbController {
        static get $inject() {
            return ['$rootScope', '$scope', '$state', 'changeViewMode', 'menuItemsFactory', '$window', '$timeout'];
        }

        constructor($rootScope, $scope, $state, changeViewMode, menuItemsFactory, $window, $timeout) {
            this.$rootScope = $rootScope;
            this.$scope = $scope;
            this.$state = $state;
            this.$window = $window;
            this.$timeout = $timeout;
            this.changeViewMode = changeViewMode;
            this.menuItemsFactory = menuItemsFactory;

            this.listeners = {};
        }

        $onInit() {
            const menuItemsFactory = this.menuItemsFactory;
            const changeViewMode = this.changeViewMode;
            const $rootScope = this.$rootScope;
            const $scope = this.$scope;
            const $state = this.$state;

            this.inWideMode = false;
            this.actions = {
                toggleWideMode: changeViewMode.toggleWideMode,
                toggleMenu: () => {
                    $rootScope.$broadcast('wtMenu:toggleMenu');
                }
            };

            this.menuItemsByState = menuItemsFactory.getByState();
            this.menuItemsById = menuItemsFactory.getById();

            // keeps track if the application is in wide mode or not.
            this.listeners.toggleViewMode = $scope.$on('wtCommon:toggleWideMode', () => {
                this.inWideMode = !this.inWideMode;
            });

            // reload breadcrumb at the start
            this.listeners.$viewContentLoaded = $scope.$watch('$viewContentLoaded', this.getBreadcrumb.bind(this));
            this.listeners.$stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', this.getBreadcrumb.bind(this));

            // reload breadcrumb when we change state (ui.route 1.0.0-alpha)
            if ($state.$transitions && $state.$transitions.onSuccess) {
                $state.$transitions.onSuccess({}, this.getBreadcrumb.bind(this));
            }
        }

        $onDestroy() {
            Object.keys(this.listeners).forEach((key) => this.listeners[key]());
        }

        getBreadcrumb() {
            let maskType = null;

            const $state = this.$state;

            if (this.head && this.tail) {
                // when the breadcrumb is given from outside
                this.breadcrumb = {
                    head: this.head,
                    tail: this.tail
                };
                return this;
            }
            this.breadcrumb = {
                head: [], // comes from menu
                tail: [] // comes from state
            };

            // MATE special case
            if ($state.current.name.endsWith('.overview')) {
                maskType = 'WT_BREADCRUMB.OVERVIEW';
            } else if ($state.current.name.endsWith('.edit')) {
                maskType = 'WT_BREADCRUMB.EDIT';
            } else if ($state.current.name.endsWith('.create')) {
                maskType = 'WT_BREADCRUMB.CREATE';
            } else if ($state.current.name.endsWith('.manage')) {
                maskType = 'WT_BREADCRUMB.MANAGE';
            }

            let currentItem = this.menuItemsByState[$state.current.name];

            if (!currentItem) {
                // special MATE case
                let parentMenuState = $state.current.name.split('.');
                parentMenuState.splice(parentMenuState.length - 1);
                parentMenuState.push('overview');
                parentMenuState = parentMenuState.join('.');
                currentItem = this.menuItemsByState[parentMenuState];
            }

            if (currentItem) {
                // get all parents titles from menu
                (currentItem.parentIds || []).forEach((parentId) => {
                    if (this.menuItemsById && this.menuItemsById[parentId]) {
                        this.breadcrumb.head.push(this.menuItemsById[parentId].title);
                    }
                });
                this.breadcrumb.head.push(currentItem.title);
            }

            if (maskType) {
                this.breadcrumb.tail.push(maskType);
            }

            return this;
        }
    }

    angular.module('wtUi.wtBreadcrumb').controller('WtBreadcrumbController', WtBreadcrumbController);
})(window.angular);
